"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEProductCard = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _FAEText = require("../FAEText/FAEText");

var _FAEPrice = require("../FAEPrice/FAEPrice");

var _FAELoading = require("../FAELoading/FAELoading");

var _FAEImage = require("../FAEImage/FAEImage");

var _FAEVideo = require("../FAEVideo/FAEVideo");

var _FAETextField = require("../FAETextField/FAETextField");

var _FAEButton = require("../FAEButton/FAEButton");

require("./FAEProductCard.scss");

const _excluded = ["src", "label", "price", "primary", "discountedPrice", "currencySymbol", "className", "type", "alt", "loading", "loaderProps", "placeholder", "textOnImage", "textPosition", "noOfProductsAdded", "shortDescription", "disabled", "onClick", "getQuantityOfProducts"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEProductCard = _ref => {
  let {
    src,
    label,
    price,
    primary,
    discountedPrice,
    currencySymbol,
    className = "",
    type,
    alt,
    loading,
    loaderProps,
    placeholder,
    textOnImage,
    textPosition,
    noOfProductsAdded = 0,
    shortDescription = "asdsadsadad",
    disabled,
    onClick = () => {},
    getQuantityOfProducts = () => {}
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [noOfProducts, setNoOfProducts] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    setNoOfProducts(noOfProductsAdded);
  }, [noOfProductsAdded]);

  const handleQuantityChanged = (event, quantity) => {
    if (event === "") {
      setNoOfProducts(parseInt(quantity));
      getQuantityOfProducts(parseInt(quantity));
    } else if (event === "add") {
      setNoOfProducts(noOfProducts + 1);
      getQuantityOfProducts(noOfProducts + 1);
    } else {
      setNoOfProducts(noOfProducts - 1);
      getQuantityOfProducts(noOfProducts - 1);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--product-card ".concat(className)
  }, type !== "video" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEImage.FAEImage, _extends({
    className: "fae--product-card-image-or-video",
    src: src,
    alt: alt,
    placeholder: placeholder,
    textOnImage: textOnImage,
    textPosition: textPosition
  }, rest))) : /*#__PURE__*/_react.default.createElement(_FAEVideo.FAEVideo, _extends({
    className: "fae--product-card-image-or-video",
    src: src,
    alt: alt,
    placeholder: placeholder
  }, rest)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--card-content"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    className: "fae--product-card-text-mobile",
    light: true
  }, label), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    paragraph: true,
    light: true,
    tertiary: true
  }, shortDescription), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--product-card-amount-of-products-action-and-price-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FAEPrice.FAEPrice, {
    discountedPrice: discountedPrice,
    price: price,
    currencySymbol: currencySymbol
  }), primary ? /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--product-card-amount-of-products-action-wrapper"
  }, noOfProducts > 0 && /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, {
    onClick: () => handleQuantityChanged("remove", 0),
    className: "fae--product-card-action-button"
  }, "-"), /*#__PURE__*/_react.default.createElement(_FAETextField.FAETextField, {
    type: "number",
    textFieldClass: "fae--product-card-text-field",
    className: "fae--product-card-text-field-cotainer",
    value: noOfProducts,
    getValue: value => handleQuantityChanged("", value === "" ? 0 : value)
  }), /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, {
    onClick: () => handleQuantityChanged("add", 0),
    className: "fae--product-card-action-button"
  }, "+")) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--product-card-amount-of-products-action-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, "Qty: "), /*#__PURE__*/_react.default.createElement(_FAETextField.FAETextField, {
    type: "number",
    textFieldClass: "fae--product-card-text-field",
    className: "fae--product-card-text-field-cotainer",
    value: noOfProducts,
    disabled: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--product-card-add-to-card-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, {
    primary: disabled,
    disabled: disabled,
    onClick: onClick
  }, "Add To Cart")))));
};

exports.FAEProductCard = FAEProductCard;